/*eslint-disable no-eval */
import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import { styles } from './style';

// icon
import {
  RainIcon, WaterLevelIcon, QualityIcon, WaveIcon, DamIcon, EwsIcon,
} from '../../assets/svg/Icon';

const useStyles = makeStyles(styles);

function Marker(props) {
  const classes = useStyles();

  const shape = eval(`classes. ${props.type.label}`);
  const category = props.category;
  return (
    <>
      <Box display="flex" className={shape} bgcolor={props.type.color} justifyContent="center" alignItems="center">
        {(category === 'rainfall') && (<RainIcon className={classes.iconSvg} />)}
				{(category === 'waterlevel') && (<WaterLevelIcon className={classes.iconSvgTriangle} />)}
				{(category === 'waterquality') && (<QualityIcon className={classes.iconSvg} />)}
				{(category === 'wave') && (<WaveIcon className={classes.iconSvg} />)}
				{(category === 'dam') && (<DamIcon className={classes.iconSvg} />)}
				{(category === 'ews') && (<EwsIcon className={classes.iconSvg} style={{color : props.type.color}}/>)}
      </Box>
    </>
  );
}

export default function MarkerData(props) {
  const { category, type } = props;

  return (
    <>
      <Marker category={category} type={type} />
    </>
  );
}

MarkerData.propTypes = {
  category: PropTypes.string.isRequired,
  type: PropTypes.object.isRequired,
};
